import React, { useState, useEffect } from 'react'; 
import StateContext from '../../helpers/ContextState';
import { PostAsync, Inputs } from '../../helpers/Functions';
import SelectorSimple from "../../components/SelectorMultipleCorrespondecia";
import BotonVolverHome from '../../components/BotonVolverHome';
import Config from '../../helpers/Config';

const Correspondencia = (props) => {

  const context = React.useContext(StateContext);

  const [usuarios, setUsuarios] = useState([]);
  const [usuariosOriginal, setUsuariosOriginal] = useState([]);

  const [nits, setNits] = useState([]);
  const [nitsOriginal, setNitsOriginal] = useState([]);

  const [tipos, setTipos] = useState([]);
  const [TiposOriginal, setTiposOriginal] = useState([]);

  const [estados, setEstado] = useState([]);
  const [estadoOriginal, setEstadoOriginal] = useState([]);

  const [naturaleza, setNaturaleza] = useState([]);
  const [naturalezaOriginal, setNaturalezaOriginal] = useState([]);

  const [asociados, setAsociados] = useState([]);
  const [asociadosOriginal, setAsociadosOriginal] = useState([]);

  const [inputs, setInputs] = useState({
    cantidad: 1
  });

  const [imprimirTodos, setImprimirTodos] = useState(false);

  const soloTipoSeleccionado =
      !imprimirTodos &&
      inputs.tipo && inputs.tipo.length > 0 &&
      (!inputs.usuario_id || inputs.usuario_id.length === 0) &&
      (!inputs.nit_id || inputs.nit_id.length === 0);
  
  const habilitarExcluidos = imprimirTodos || soloTipoSeleccionado;

  useEffect(() => {
    getInit();
  }, []);

  const getInit = () => {

    PostAsync("Users", "GetUsuarioCorrespondencia", {}, context)
      .then((response) => {

        if (!response) return;

        if (response.usuarios) {
          setUsuarios(response.usuarios);
          setUsuariosOriginal(response.usuarios);
        }

        if (response.nro_documentos) {
          setNits(response.nro_documentos);
          setNitsOriginal(response.nro_documentos);
        }

        if (response.tipos) {
          setTipos(response.tipos);
          setTiposOriginal(response.tipos);
        }

        if (response.estados) {
          setEstado(response.estados);
          setEstadoOriginal(response.estados);
        }

        if (response.naturaleza) {
          setNaturaleza(response.naturaleza);
          setNaturalezaOriginal(response.naturaleza);
        }

        if (response.asociados) {
          setAsociados(response.asociados);
          setAsociadosOriginal(response.asociados);
        }
      });
  };

  const imprimirEtiquetas = () => {

    const usuariosSeleccionados = inputs.usuario_id
      ? inputs.usuario_id.map(u => u.value)
      : [];

    const nitsSeleccionados = inputs.nit_id
      ? inputs.nit_id.map(n => n.value)
      : [];

    const tiposSeleccionados = inputs.tipo
      ? inputs.tipo.map(t => t.value)
      : [];

    const naturalezaSeleccionada = inputs.naturaleza
      ? inputs.naturaleza.map(n => n.value)
      : [];

    const asociadosSeleccionados = inputs.asociado
      ? inputs.asociado.map(a => a.value)
      : [];

    const estadosSeleccionados = inputs.estado
      ? inputs.estado.map(e => e.value)
      : [];

    const hayFiltros =
      usuariosSeleccionados.length ||
      nitsSeleccionados.length ||
      tiposSeleccionados.length ||
      naturalezaSeleccionada.length ||
      asociadosSeleccionados.length ||
      estadosSeleccionados.length;

    if (!imprimirTodos && !hayFiltros) {
      context.setModalShow({
        show: true,
        size: "sm",
        message: (
          <div className="text-center">
            <div className="mb-3">Debe seleccionar al menos un filtro.</div>
            <div className="btn btn-primary mt-3" onClick={() => context.setModalShow({ show: false, message: "", size: "sm" })}>
              Cerrar
            </div>
          </div>
        ),
      });
      return;
    }

    const usuariosExcluidos = inputs.UsuariosExcluidos
      ? inputs.UsuariosExcluidos.map(u => u.value)
      : [];

    const paramsPDF = new URLSearchParams({
      imprimir_todos: imprimirTodos ? 1 : 0,
      usuarios: JSON.stringify(usuariosSeleccionados),
      nits: JSON.stringify(nitsSeleccionados),
      tipo: JSON.stringify(tiposSeleccionados),
      naturaleza: JSON.stringify(naturalezaSeleccionada),
      asociados: JSON.stringify(asociadosSeleccionados),
      estado: JSON.stringify(estadosSeleccionados),

      excluidos: JSON.stringify(usuariosExcluidos)
    });

    const url = Config.ConfigApirest + "PDF/Users/EtiquetasCorrespondenciaWord?" + paramsPDF.toString();
    window.open(url, '_blank');
  };

  const onChangeCustom = (selectedOption, name) => {

    if (!selectedOption || selectedOption.length === 0) {

      setInputs(prev => ({
        ...prev,
        [name]: []
      }));

      setUsuarios(usuariosOriginal);
      setNits(nitsOriginal);
      setTipos(TiposOriginal);
      setEstado(estadoOriginal);
      setNaturaleza(naturalezaOriginal);
      setAsociados(asociadosOriginal);

      if (name === "tipo") {

        setInputs(prev => ({
          ...prev,
          tipo: [],
          usuario_id: [],
          nit_id: [],
          estado: [],
          naturaleza: [],
          asociado: []
        }));

      }

      if (name === "nit_id" || name === "usuario_id") {

        setInputs(prev => ({
          ...prev,
          usuario_id: [],
          nit_id: [],
          tipo: [],
          estado: [],
          naturaleza: [],
          asociado: []
        }));

      }

      if (name === "estado" || name === "naturaleza" || name === "asociado") {

        setInputs(prev => ({
          ...prev,
          estado: [],
          naturaleza: [],
          asociado: [],
          usuario_id: [],
          nit_id: [],
          tipo: []
        }));

      }

      return;
    }

    if (name === "tipo") {

      const tiposSeleccionados = selectedOption.map(t => String(t.value));

      const usuariosFiltrados = usuariosOriginal.filter(
        u => tiposSeleccionados.includes(String(u.tipo))
      );

      const nitsFiltrados = nitsOriginal.filter(
        n => tiposSeleccionados.includes(String(n.tipo))
      );

      setUsuarios(usuariosFiltrados);
      setNits(nitsFiltrados);

      setInputs(prev => ({
        ...prev,
        tipo: selectedOption,
        usuario_id: [],
        nit_id: []
      }));

      return;
    }

    if (name === "usuario_id") {

      const usuarioOptions = selectedOption.map(sel => {
        const u = usuariosOriginal.find(x => String(x.value) === String(sel.value));
        return {
          value: u ? u.value : sel.value,
          label: u ? u.nit : (sel.label || "")
        };
      });

      const tiposSeleccionadosIds = [
        ...new Set(selectedOption.map(sel => {
          const u = usuariosOriginal.find(x => String(x.value) === String(sel.value));
          return u ? String(u.tipo) : null;
        }).filter(Boolean))
      ];

      const tipoOptions = tipos.filter(t => tiposSeleccionadosIds.includes(String(t.value)));

      const usuariosSeleccionados = selectedOption.map(sel =>
        usuariosOriginal.find(x => String(x.value) === String(sel.value))
      );

      const estadosDetectados = [...new Set(usuariosSeleccionados.map(u => u.estatus))];
      let estadoOption = [];

      if (estadosDetectados.length === 1) {
        estadoOption = estados.filter(e =>
          (estadosDetectados[0] == 1 && e.value == 1) ||
          (estadosDetectados[0] == 2 && e.value == 2)
        );
      } else {
        estadoOption = estados.filter(e => e.value == 3);
      }

      const naturalezasDetectadas = [...new Set(usuariosSeleccionados.map(u => u.naturaleza))];
      let naturalezaOption = [];

      if (naturalezasDetectadas.length === 1) {
        naturalezaOption = naturaleza.filter(n => n.value == naturalezasDetectadas[0]);
      } else {
        naturalezaOption = naturaleza.filter(n => n.value == 3);
      }

      const asociadosDetectados = [...new Set(usuariosSeleccionados.map(u => u.asociado))];
      let asociadoOption = [];

      if (asociadosDetectados.length === 1) {
        asociadoOption = asociados.filter(a => a.value == asociadosDetectados[0]);
      } else {
        asociadoOption = asociados.filter(a => a.value == 3);
      }

      setInputs(prev => ({
        ...prev,
        usuario_id: selectedOption,
        nit_id: usuarioOptions,
        tipo: tipoOptions,
        estado: estadoOption,
        naturaleza: naturalezaOption,
        asociado: asociadoOption
      }));

      return;
    }

    if (name === "nit_id") {

      const nitOptions = selectedOption.map(sel => {
        const n = nitsOriginal.find(x => String(x.value) === String(sel.value));
        return {
          value: n ? n.value : sel.value,
          label: n ? n.label || n.nombre || "" : (sel.label || "")
        };
      });

      const usuarioOptions = selectedOption.map(sel => {
        const u = usuariosOriginal.find(x => String(x.value) === String(sel.value));
        return {
          value: u ? u.value : sel.value,
          label: u ? u.label : (sel.label || "")
        };
      });

      const tiposSeleccionadosIds = [
        ...new Set(selectedOption.map(sel => {
          const n = nitsOriginal.find(x => String(x.value) === String(sel.value));
          return n ? String(n.tipo) : null;
        }).filter(Boolean))
      ];

      const tipoOptions = tipos.filter(t => tiposSeleccionadosIds.includes(String(t.value)));

      const usuariosSeleccionados = selectedOption.map(sel =>
        usuariosOriginal.find(x => String(x.value) === String(sel.value))
      );

      const estadosDetectados = [...new Set(usuariosSeleccionados.map(u => u.estatus))];
      let estadoOption = [];

      if (estadosDetectados.length === 1) {
        estadoOption = estados.filter(e =>
          (estadosDetectados[0] == 1 && e.value == 1) ||
          (estadosDetectados[0] == 2 && e.value == 2)
        );
      } else {
        estadoOption = estados.filter(e => e.value == 3);
      }

      const naturalezasDetectadas = [...new Set(usuariosSeleccionados.map(u => u.naturaleza))];
      let naturalezaOption = [];

      if (naturalezasDetectadas.length === 1) {
        naturalezaOption = naturaleza.filter(n => n.value == naturalezasDetectadas[0]);
      } else {
        naturalezaOption = naturaleza.filter(n => n.value == 3);
      }

      const asociadosDetectados = [...new Set(usuariosSeleccionados.map(u => u.asociado))];
      let asociadoOption = [];

      if (asociadosDetectados.length === 1) {
        asociadoOption = asociados.filter(a => a.value == asociadosDetectados[0]);
      } else {
        asociadoOption = asociados.filter(a => a.value == 3);
      }

      setInputs(prev => ({
        ...prev,
        nit_id: selectedOption,
        usuario_id: usuarioOptions,
        tipo: tipoOptions,
        estado: estadoOption,
        naturaleza: naturalezaOption,
        asociado: asociadoOption
      }));

      return;
    }

    if (name === "estado" || name === "naturaleza" || name === "asociado") {

      let usuariosFiltrados = [...usuariosOriginal];

      if (name === "estado") {

        const val = selectedOption[0].value;

        if (val != 3) {
          usuariosFiltrados = usuariosFiltrados.filter(
            u => (val == 1 ? u.estatus == 1 : u.estatus == 2)
          );
        }

      }

      if (name === "naturaleza") {

        const val = selectedOption[0].value;

        if (val != 3) {
          usuariosFiltrados = usuariosFiltrados.filter(
            u => u.naturaleza == val
          );
        }

      }

      if (name === "asociado") {

        const val = selectedOption[0].value;

        if (val != 3) {
          usuariosFiltrados = usuariosFiltrados.filter(
            u => u.asociado == val
          );
        }

      }

      const nitsFiltrados = usuariosFiltrados.map(u => ({
        label: u.nit,
        value: u.value
      }));

      setUsuarios(usuariosFiltrados);
      setNits(nitsFiltrados);

      setInputs(prev => ({
        ...prev,
        [name]: selectedOption
      }));

      return;
    }

    setInputs(prev => ({
      ...prev,
      [name]: selectedOption
    }));
  };

    useEffect(() => {
      if (!habilitarExcluidos) {
        setInputs(prev => ({
          ...prev,
          UsuariosExcluidos: []
        }));
      }
    }, [habilitarExcluidos]);

  return (
    <div className="container">
      <BotonVolverHome />

      <div className="p-2 text-end">
        <div
          className="btn btn-primary btn-xl"
          onClick={imprimirEtiquetas}
        >
          Imprimir
        </div>
      </div>

      <div className="row bg-light p-3 mb-4 border rounded">
        <h5>Generar etiquetas de correspondencia</h5>

        <div className="col-md-3">
          <SelectorSimple
            name="nit_id"
            title="NIT"
            data={nits}
            inputs={inputs}
            onChange={onChangeCustom}
            setInputs={setInputs}
            disabled={imprimirTodos}
            className="form-control"
          />
        </div>

        <div className="col-md-3">
          <SelectorSimple
            name="usuario_id"
            title="Nombre"
            data={usuarios}
            inputs={inputs}
            onChange={onChangeCustom}
            setInputs={setInputs}
            disabled={imprimirTodos}
            className="form-control"
          />
        </div>

        <div className="col-md-3">
          <SelectorSimple
            name="estado"
            title="Estado del usuario"
            data={estados}
            inputs={inputs}
            onChange={onChangeCustom}
            setInputs={setInputs}
            disabled={imprimirTodos}
            className="form-control"
          />
        </div>

        <div className="col-md-3">
          <SelectorSimple
            name="tipo"
            title="Tipo de usuario"
            data={tipos}
            inputs={inputs}
            onChange={onChangeCustom}
            setInputs={setInputs}
            disabled={imprimirTodos}
            className="form-control"
          />
        </div>

        <div className="col-md-3">
          <SelectorSimple
            name="naturaleza"
            title="Persona"
            data={naturaleza}
            inputs={inputs}
            onChange={onChangeCustom}
            setInputs={setInputs}
            disabled={imprimirTodos}
            className="form-control"
          />
        </div>

        <div className="col-md-3">
          <SelectorSimple
            name="asociado"
            title="Asociado"
            data={asociados}
            inputs={inputs}
            onChange={onChangeCustom}
            setInputs={setInputs}
            disabled={imprimirTodos}
            className="form-control"
          />
        </div>

        <div className="col-md-3">
          <SelectorSimple
            name="UsuariosExcluidos"
            title="Usuarios Excluidos"
            data={usuarios}
            inputs={inputs}
            onChange={onChangeCustom}
            setInputs={setInputs}
            disabled={!habilitarExcluidos}
            className="form-control"
          />
        </div>

        <div className="col-md-3">
          <div className="form-check mt-4">
            <input
              type="checkbox"
              className="form-check-input"
              id="imprimirTodos"
              checked={imprimirTodos}
              onChange={(e) => {
                setImprimirTodos(e.target.checked);

                if (e.target.checked) {
                  setInputs(prev => ({
                    ...prev,
                    usuario_id: [],
                    nit_id: [],
                    tipo: []
                  }));

                  setUsuarios(usuariosOriginal);
                  setNits(nitsOriginal);
                  setTipos(TiposOriginal);
                }
              }}
            />
            <label className="form-check-label">
              Imprimir todos
            </label>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Correspondencia;